/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCircleCI extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCircleCI");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCircleCI.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCircleCI>): ServiceAccountNativeDetailsForCircleCI {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCircleCI(), model);
        ServiceAccountNativeDetailsForCircleCI.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCircleCI>): ServiceAccountNativeDetailsForCircleCI {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCircleCI.newInstance(<ServiceAccountNativeDetailsForCircleCI> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCircleCI) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCircleCI.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCircleCI): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCircleCI.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
